import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { FormFieldOption } from '@shared/shared/form-fields';
import { FormOptionsService, OptionsGroup } from '@shared/shared';
import { convertApiItemResponseToItem, Store } from '@shared/core/utils';
import { BackendApiResponse, DEFAULT_REQUEST_PARAMS } from '@shared/core/types';
import { HttpErrorResponse } from '@angular/common/http';
import { AppApiService } from '@shared/core';
import { environment } from '@environment';

const initialState = {
  timezoneList: [] as FormFieldOption[],
};

export type TimezoneResponse = BackendApiResponse<OptionsGroup[]>;

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  protected baseEndpoint = environment.crm.backend.baseEndpoint;
  private store = new Store<typeof initialState>(initialState);
  private store$ = this.store.asReadonly();

  constructor(private formOptionsService: FormOptionsService, protected api: AppApiService) {}

  getList(): Observable<FormFieldOption[]> {
    this.loadList();

    return this.store$.select('timezoneList');
  }

  private loadList(): void {
    (this.formOptionsService.getOptions('persons/suggest/utc-offsets/', false) as Observable<FormFieldOption[]>)
      .pipe(
        tap(timezoneList =>
          this.store.update(state => ({
            ...state,
            timezoneList,
          })),
        ),
      )
      .subscribe();
  }

  getTimezone(): Observable<OptionsGroup[]> {
    return timer(0, 60000).pipe(
      switchMap(() => {
        return this.api.get<TimezoneResponse>(`${this.baseEndpoint}persons/suggest/timezones/`, {
          ...DEFAULT_REQUEST_PARAMS,
        });
      }),
      convertApiItemResponseToItem,
      catchError((error: HttpErrorResponse) => {
        throw error.error;
      }),
    );
  }
}
